var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.94 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.748 15c-1.31-.06-2.468-.521-3.547-1.214-1.065-.684-1.977-1.545-2.825-2.479-.804-.886-1.54-1.823-2.148-2.856C.664 7.496.224 6.49.066 5.385c-.204-1.423.049-2.75.986-3.877.324-.39.741-.704 1.118-1.05.09-.082.184-.16.283-.23.448-.316.904-.314 1.296.07.306.3.574.645.818.998.344.5.685 1.006.875 1.594.231.717.08 1.268-.497 1.749-.267.221-.54.437-.814.649-.467.36-.608.81-.435 1.414.17.596.501 1.105.87 1.59.628.83 1.296 1.625 2.144 2.239.292.21.626.38.965.5.424.15.81.017 1.136-.3.288-.28.581-.556.885-.82.495-.432 1.061-.495 1.63-.195.394.209.765.475 1.11.759.399.328.768.695 1.129 1.065.131.135.219.322.296.498.146.333.09.668-.153.92-.755.777-1.543 1.523-2.635 1.802-.434.112-.883.162-1.325.24",
    fill: "#97bf2c",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1ae5d92a24d2e2c03e50f49adcd7932e.svg";
export { ForwardRef as ReactComponent };